import forge from 'node-forge';

export default forge;